<template>

    <div class="fl-post-grid-meta">

        <div class="fl-post-grid-date">

            <span v-if="parseInt(moduleSettings.show_date) == 1" class="fl-post-grid-date">
                {{ postDate }}
            </span>

        </div>

        <div v-if="parseInt(moduleSettings.show_source) == 1 || parseInt(moduleSettings.show_categories) == 1" class="fl-post-grid-source">
            <span class="fl-post-source">
                {{ moduleSettings.sources[parseInt(postObj.source)].label_position == 1 ? postLabel : postTerm }}
            </span>
        </div>
    </div>

</template>

<script>
export default {
  props: {
    postObj: {
      type: Object
    },
    moduleSettings: {
      type: Object
    },
    postLabel: {
      type: String
    },
    postTerm: {
      type: String
    }
  },
  computed: {
    postDate: function () {
      if (!this.postObj.date.includes('T')) {
        return this.postObj.date
      }

      const date = new Date(this.postObj.date)
      const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
      return date.toLocaleDateString('fi-FI', options)
    }
  }
}
</script>
